/**
 * @file index.tsx
 *
 * @fileoverview Default slot for optimized fonts.
 */
export const NextFontSlot = ({ children }) => null;
